import React, { ChangeEvent, useState } from 'react';
import TableFiltersWrapper from 'ui/TableInputs/TableFiltersWrapper/TableFiltersWrapper';
import TableInput from 'ui/TableInputs/TableInput/TableInput';

interface IRecallPepaidFilter {
  onSubmitFilters: (query: ISearchParams) => void;
}
export interface ISearchParams {
  customerId?: string;
  scheduleId?: string;
}

const RecallPepaidFilter = ({ onSubmitFilters }: IRecallPepaidFilter) => {
  const [state, setState] = useState<ISearchParams>({
    customerId: '',
    scheduleId: '',
  });
  const updateState = (update: Partial<ISearchParams>) => setState((current) => ({ ...current, ...update }));

  const handleFilterChange = (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    const { name, value } = e.target;
    return updateState({ [name as keyof ISearchParams]: value as string });
  };

  const handleClearInput = (name: string) => () => {
    updateState({ [name as keyof ISearchParams]: '' });
  };

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmitFilters(state);
  };
  const styles = {
    marginTop: '20px',
  };

  return (
    <>
      <div style={styles}>
        <form onSubmit={handleOnSubmit}>
          <TableFiltersWrapper>
            <TableInput
              name="customerId"
              label="Customer ID"
              onClickClear={handleClearInput('customerId')}
              value={state.customerId}
              fullWidth
              onChange={handleFilterChange}
              autoComplete="off"
              showIcon
            />
            <TableInput
              name="scheduleId"
              label="Schedule ID"
              onClickClear={handleClearInput('scheduleId')}
              value={state.scheduleId}
              fullWidth
              onChange={handleFilterChange}
              autoComplete="off"
              showIcon
            />
          </TableFiltersWrapper>
        </form>
      </div>
    </>
  );
};

export default RecallPepaidFilter;
